<template>
	<div class="com-container" @dblclick="revertMap">
		<!-- 地图组件 -->
		<div class="com-chart" ref="map_ref"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	// 导入工具文件
	import {
		getProvinceMapInfo
	} from '@/utils/map_utils'

	export default {
		data() {
			return {
				chartInstane: null, // echart实例对象
				// allData: null, // 从服务器中获取的所有数据
				mapData: {}, // 所获取的省份的地图矢量数据
				allData: [{
						"name": "黄金用户",
						"children": [{
							"name": "武汉",
							"value": [114.31, 30.52]
						}, {
							"name": "丹东",
							"value": [124.37, 40.13]
						}, {
							"name": "张家口",
							"value": [114.87, 40.82]
						}, {
							"name": "深圳",
							"value": [114.07, 22.62]
						}]
					},
					{
						"name": "白金用户",
						"children": [{
							"name": "金华",
							"value": [119.64, 29.12]
						}, {
							"name": "西安",
							"value": [108.95, 34.27]
						}]
					},
					{
						"name": "砖石用户",
						"children": [{
							"name": "成都",
							"value": [104.06, 30.67]
						}]
					}
				],

			}
		},
		mounted() {
			this.initChart()
			this.getData()
			window.addEventListener('resize', this.screenAdapter) // 分辨率的适配
			this.screenAdapter() // 主动调一次各种尺寸的计算
		},
		destroyed() {
			window.removeEventListener('resize', this.screenAdapter) // 取消监听
		},
		methods: {
			diaoyong (data) {
				this.chartInstane = this.echarts.init(this.$refs.map_ref, 'chalk') 
				this.chartInstance.setOption(data)
			},
			async initChart() { // 初始化实例对象的方法  async initChart()
				this.chartInstane = this.echarts.init(this.$refs.map_ref, 'chalk') // vintage chalk

				// 1. 获取中国地图的矢量数据    http://localhost:8088/static/map/province/jiangxi.json
				// http://localhost:8088/static/map/china.json
				const ret = await axios.get('http://localhost:8088/static/map/china.json')
				const ret_jx = await axios.get('http://localhost:8088/static/map/province/jiangxi.json')
				
				console.log(ret)

				// 2. 注册地图数据为 china 别名
				this.echarts.registerMap('china', ret)
				this.echarts.registerMap('jiangxi', ret_jx)

				// 3. 配置geo
				const initOption = {
					title: { // 标题
						text: '▎ 商家分布',
						left: 20,
						top: 20
					},
					geo: {
						type: 'map',
						map: 'china',
						// map: 'jiangxi',
						top: '5%', // 地图的位置，大小
						bottom: '5%', // 地图的位置，大小
						itemStyle: { // 地图每个省份的颜色和边框的颜色
							areaColor: '#2E72BF',
							borderColor: '#333'
						}
					},
					legend: { // 图例的位置
						left: '5%',
						bottom: '5%',
						orient: 'vertical' //  图例摆放的方向是垂直方向  默认是水平  
					}
				}
				this.chartInstane.setOption(initOption) // 形成地图
				let that = this

                this.chartInstane.off('click') 
				// this.chartInstane.on('click',async  (arg) => { // arg 包含被点击省份的信息  
				this.chartInstane.on('click', (arg) => { // arg 包含被点击省份的信息
					console.log("地图被点击")
					// console.log(arg)
					// console.log(arg.name) // arg.name 得到所点击的省份, 这个省份他是中文
					// // 通过一个工具 将中文隐射到拼音文件
					// const provinceInfo = getProvinceMapInfo(arg.name) // 返回是一个对象 对象有两个值 provinceInfo.key 是省份拼音  ； provinceInfo.path 是 该省份的地图json文件的路径
					// console.log(provinceInfo)
					// // 需要获取这个省份的地图矢量数据
					// // 判断当前所点击的这个省份的地图矢量数据在mapData中是否存在
					// // if (!this.mapData[provinceInfo.key]) {
					// const url = 'http://localhost:8088' + provinceInfo.path
					// console.log("url=" + url)
					// const ret = await axios.get(url)
					// // const ret = await axios.get(url)
					// console.log("---")
					// console.log(ret)
					// // this.mapData[provinceInfo.key] = ret
					// this.echarts.registerMap(provinceInfo.key, ret)
					// // }
					const changeOption = {
						geo: {
							// map: provinceInfo.key
							map: 'jiangxi'
						}
					}
					// this.diaoyong(changeOption)
					this.chartInstance.setOption(changeOption)
					// this.chartInstance.setOption(changeOption)
				})
			},
			getData() { // 获取散点图数据
				// this.getRequest('/work_log/header_index1').then(resp => {
				// 	if (resp) {
				// 		this.allData = resp.data
				// 最终将获取到的数据放入  this.allData中
				this.updateChart() // 更新图表
				// 	}
				// })
			},
			updateChart() { //处理数据  更新数据
				// 获取图例的数据
				const legendArr = this.allData.map(item => {
					return item.name
				})

				// 处理数据
				const seriesArr = this.allData.map(item => {
					// return的这个对象就代表的是一个类别下的所有散点数据
					// 如果想在地图中显示散点的数据, 我们需要给散点的图表增加一个配置, coordinateSystem:geo
					return {
						type: 'effectScatter', //涟漪效果
						rippleEffect: { // 涟漪效果 
							scale: 5, // 涟漪效果明显
							brushType: 'stroke' //空心的涟漪效果
						},
						name: item.name, // 散点类别名称
						data: item.children,
						coordinateSystem: 'geo' // 散点使用地图坐标系统
					}
				})
				const dataOption = {
					legend: { // 配置图例
						data: legendArr
					},
					series: seriesArr //配置散点数据
				}
				// const  chartInstane1 = 
				// this.echarts.init(this.$refs.map_ref, 'chalk').setOption(dataOption)
				// chartInstane1.setOption(dataOption)
				this.chartInstane.setOption(dataOption)
			},
			screenAdapter() {
				// this.titleFontSize = this.$refs.map_ref.offsetWidth / 100 * 3.6
				const titleFontSize = this.$refs.map_ref.offsetWidth / 100 * 3.6
				const adapterOption = {
					title: {
						textStyle: {
							fontSize: titleFontSize
						}
					},
					legend: {
						itemWidth: titleFontSize / 2, //图例大小
						itemHeight: titleFontSize / 2, //图例大小
						itemGap: titleFontSize / 2, // 图例之间的间隔
						textStyle: {
							fontSize: titleFontSize / 2 //图例旁边的文字大小
						}
					}
				}
				this.chartInstane.setOption(adapterOption)
				this.chartInstane.resize()
			},
			// 回到中国地图
			revertMap() {
				const revertOption = {
					geo: {
						map: 'china'
					}
				}
				this.chartInstance.setOption(revertOption)
			}
		}
	}
</script>

<style>
</style>
